export default function Navigation() {
  return null;
}